import { Component, h } from 'preact';

import {getAll, save} from '../../preferences';
import { Title, InputGroup, Label, Input } from './styled';

class Settings extends Component {
  state = {
    values: {
      functionality_storage: true //required cookies
    },
    message: false
  };

  componentWillMount() {
    const groupsByKes = this.props.groups.reduce(
      (obj, val) => ((obj[val.id] = val), obj),
      {}
    );

    const saved = getAll();
    const groups = Object.keys(groupsByKes).reduce((acc, id) => {
      const group = groupsByKes[id];

      if(saved.indexOf(id) !== -1) {
        acc[id] = true;
      } else if ('checked' in group) {
        acc[id] = group.checked;
      } else {
        acc[id] = false
      }

      return acc;
    }, {});

    this.setState({
      values: {
        ...groups,
        ...this.state.values
      }
    });
  }

  toggleChange = e => {
    e.preventDefault();
    const { name } = e.target;

    this.setState(prevState => {
      return {
        values: {
          ...prevState.values,
          [name]: !prevState.values[name]
        }
      };
    });
  };

  handleSave = e => {
    e.preventDefault();
    save(this.state.values);
  };

  render(props, state) {
    const { title, groups } = props;

    return (
      <div>
        <div>
          {title && <Title>{title}</Title>}
          <form>
            {groups.map(({ id, description, title, disabled }) => (
              <InputGroup disabled={disabled}>
                <label>
                  <input
                    type="checkbox"
                    disabled={disabled}
                    onChange={this.toggleChange}
                    checked={state.values[id]}
                    name={id}
                    style="margin: 0; width: auto;"
                  />
                  <Label>{title}</Label>
                </label>
              </InputGroup>
            ))}
          </form>
        </div>
      </div>
    );
  }
}

export default Settings;
